import React, { Ref } from 'react';

import { InputTekst, InputType } from '../../components/input/input-text';
import { TextInputSize } from '../../types/generated-types';
import { FocusableHtmlElement } from '../hooks';
import { isCurrentSporsmalValid } from '../reducer/current-steg';
import { updateSvar } from '../reducer/sporsmalsflyt-actions';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { CurrentForsikringsnummerSporsmal } from './forsikringsnummer-types';

interface Props {
    currentSporsmal: CurrentForsikringsnummerSporsmal;
    showFeilmelding: boolean;
    focusOnMount: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
}

export const Forsikringsnummer = ({ currentSporsmal, showFeilmelding, focusOnMount, errorRef }: Props) => {
    const dispatch = useSporsmalsflytDispatch();

    const onChange = (value: string) => {
        dispatch(updateSvar(value));
    };

    return (
        <div className="container__standard-width">
            <InputTekst
                tittel={currentSporsmal.sporsmal.tekst}
                ingress={currentSporsmal.sporsmal.ingress}
                verdi={currentSporsmal.forsikringsnummer || ''}
                onChange={onChange}
                feilmelding="Forsikringsnummer må oppgis"
                isValid={!showFeilmelding || isCurrentSporsmalValid(currentSporsmal)}
                size={TextInputSize.Smaller}
                focusOnMount={focusOnMount}
                errorRef={errorRef}
                type={InputType.Number}
                id={`forsikringsnummer-sporsmal-${currentSporsmal.sporsmal.id}`}
                key={`forsikringsnummer-sporsmal-${currentSporsmal.sporsmal.id}`}
            />
        </div>
    );
};
